import { pickingReportActions } from '../../../actions/pickingReportActions'
import { TypeBtn } from '../types/typeBtn'
import { usePickingReport } from '../../../Context/usePickingReport'

export const useColorBtn = () => {
  const { setBtnType } = pickingReportActions()
  const { state, dispatch } = usePickingReport()
  const { btnType } = state

  const handleChangeType = (value: TypeBtn) => dispatch(setBtnType(value))

  const handleChangeColor = (buttonType: TypeBtn) =>
    btnType === buttonType ? 'primary' : 'inherit'

  return { btnType, handleChangeType, handleChangeColor }
}
